import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService } from '../commons/abstract.service';
import { CustomField } from '../models/custom-field.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomFieldService extends AbstractService<CustomField> {

  getURLBase(): string {
    return '/fields-custom';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: CustomField): void {
    delete obj?._id;
  }

  preUpdate(obj: CustomField): void {
  }

  /** `scope` narrows to CONTACT or CUSTOMER fields (E2 RF-17); omitted, the API answers the contact's fields. */
  override getList(name?: string, scope?: string): Observable<CustomField[]> {
    const params: Record<string, string> = {};
    if (name) params['name'] = name;
    if (scope) params['scope'] = scope;
    return super.getWithParams('/list', params);
  }
}
